import React from 'react';
import $ from "jquery";
import { Button, Grid, Table } from 'semantic-ui-react';
import TextField from '@material-ui/core/TextField';

import Title from '../../title';
import Server from '../../../functions/server';
import HSNReport from './HSNReport';
import Permission from '../../../functions/permission';
import getFormatedDate from '../../../functions/date';
import Loading from '../../loading';

class PurchaserGSTReport extends React.Component {

  state = {
    fromDate1: getFormatedDate(new Date(), 0),
    toDate1: getFormatedDate(new Date(), 0),
    fromDate: '2021-05-03',
    toDate: '2021-05-03', branchId: 'ALL',
    branchOption: [], dropDown: 'ALL', dropdowngstin: 'ALL',
    data: [], menuPermission: []
  }

  removePercentage(value) {
    try { value = value.split('%')[0]; }
    catch (e) { value = 0.00; }
    return value;
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('gst-purchase-report', this.props.menus);
    if (menuPermission.view) {
      this.getBranch();
    }
    this.setState({ menuPermission })
  }

  getBranch() {
    let context = this;
    context.setState({ load: true, message: 'Getting Branchs' });
    $.ajax({
      type: 'POST',
      url: Server() + 'branchdetails/getallbranchs.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ load: false, branchOption: data });
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  selectBranch = event => {
    let value = event.target.value;
    if (value == 'ALL') {
      this.setState({ dropDown: value, branchId: value })
    }
    else {
      let branchId = value.split('->')[0];
      let branchName = value.split('->')[1];
      this.setState({ branchId, dropDown: branchName })
    }
  }

  selectGstin = event => { this.setState({ dropdowngstin: event.target.value }) }

  getPurchaseGstReport() {
    let context = this;
    this.setState({ load: true, message: 'Getting GST REPORT!!!!' })
    $.ajax({
      type: 'POST',
      data: { 'from_date': context.state.fromDate, 'to_date': context.state.toDate,
              'branch_id': context.state.branchId, 'dropdowngstin': context.state.dropdowngstin },
      url: Server() + 'purchasegstreport/get.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ data: data, load: false })
        } catch (e) {
          alert('Error to get Data!!!');
          context.setState({ load: false })
        }
      },
      error: function (e) {
        context.setState({ load: false });
      }
    });
  }

  fullTax(value) {
    value = this.removePercentage(value);
    return 'GST@'+value+'%';
  }

  fullTaxIGST(value) {
    value = this.removePercentage(value);
    return 'GST@'+value+'%';
  }

  fullTaxIGSTVALUE(value) {
    value = this.removePercentage(value);
    return 'IGST @'+value+'%';
  }

  halfTax(value, type) {
    value = this.removePercentage(value); value = value/2;
    return type+' @'+value+'%';
  }

  getRow(cc) {
    let i;
    let taxableAmount = 0;
    let taxAmount = 0;
    let row = [];
    let overalltotal = 0;
    let lengthItem = 0;
    lengthItem = Object.keys(cc).length;
    lengthItem = lengthItem - 9;
    let tax = 0;
    if (Object.values(cc)[5] == 'Tamil Nadu') {
      for (i = 0; i < lengthItem; i++) {
        let total = this.convertToNumber(Object.values(cc)[i + 9]);
        tax = this.separateTax(Object.keys(cc)[i + 9]);
        overalltotal = overalltotal + (total + ((total * tax)/100));
        taxableAmount = taxableAmount + total;
        taxAmount = taxAmount + ((total * tax)/100);
        row.push(<Table.Cell><div style={{textAlign: 'right'}}>{this.taxableAmount(Object.values(cc)[i + 9], Object.keys(cc)[i + 9])}</div></Table.Cell>);
        row.push(<Table.Cell><div style={{textAlign: 'right'}}>{this.taxAmount(Object.values(cc)[i + 9], Object.keys(cc)[i + 9], 2)}</div></Table.Cell>);
        row.push(<Table.Cell><div style={{textAlign: 'right'}}>{this.taxAmount(Object.values(cc)[i + 9], Object.keys(cc)[i + 9], 2)}</div></Table.Cell>);
      }
      for (var ii = 0; ii < lengthItem; ii++) {
        row.push(<Table.Cell><div style={{textAlign: 'right'}}>{'0.00'}</div></Table.Cell>);
        row.push(<Table.Cell><div style={{textAlign: 'right'}}>{'0.00'}</div></Table.Cell>);
      }
    }
    else {
      for (let ii = 0; ii < lengthItem; ii++) {
        row.push(<Table.Cell><div style={{textAlign: 'right'}}>{'0.00'}</div></Table.Cell>);
        row.push(<Table.Cell><div style={{textAlign: 'right'}}>{'0.00'}</div></Table.Cell>);
        row.push(<Table.Cell><div style={{textAlign: 'right'}}>{'0.00'}</div></Table.Cell>);
      }
      for (i = 0; i < lengthItem; i++) {
        let total = this.convertToNumber(Object.values(cc)[i + 9]);
        tax = this.separateTax(Object.keys(cc)[i + 9]);
        overalltotal = overalltotal + (total + ((total * tax)/100));
        taxableAmount = taxableAmount + total;
        taxAmount = taxAmount + ((total * tax)/100);
        row.push(<Table.Cell><div style={{textAlign: 'right'}}>{this.taxableAmount1(Object.values(cc)[i + 9], Object.keys(cc)[i + 9])}</div></Table.Cell>);
        row.push(<Table.Cell><div style={{textAlign: 'right'}}>{this.taxAmount(Object.values(cc)[i + 9], Object.keys(cc)[i + 9], 1)}</div></Table.Cell>);
      }
    }
    overalltotal = this.convertToNumber(overalltotal);
    overalltotal = Math.round(overalltotal);
    row.push(<Table.Cell><div style={{textAlign: 'right'}}>{this.makeIntoDecimal(taxableAmount)}</div></Table.Cell>);
    row.push(<Table.Cell><div style={{textAlign: 'right'}}>{this.makeIntoDecimal(taxAmount)}</div></Table.Cell>);
    row.push(<Table.Cell><div style={{textAlign: 'right'}}>{overalltotal}</div></Table.Cell>);
    return row;
  }

  makeIntoDecimal(value) {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  convertToNumber(value) {
    try { value = Number(value); }
    catch (e) { value = 0; }
    return value;
  }

  separateTax(tax) {
    try { tax = tax.split('%')[0]; }
    catch (e) { tax = 0; }
    tax = this.convertToNumber(tax);
    return tax;
  }

  taxableAmount(value, tax) {
    value = this.convertToNumber(value);
    try { tax = tax.split('%')[0]; }
    catch (e) { tax = 0; }
    tax = this.convertToNumber(tax);
    try { value = value.toFixed(2); }
    catch (e) { value = 0.00; }
    return value;
  }

  taxableAmount1(value, tax) {
    value = this.convertToNumber(value);
    try { tax = tax.split('%')[0]; }
    catch (e) { tax = 0; }
    tax = this.convertToNumber(tax);
    try { value = value.toFixed(2); }
    catch (e) { value = 0.00; }
    return value;
  }

  taxAmount(value, tax, division) {
    value = this.convertToNumber(value);
    try { tax = tax.split('%')[0]; }
    catch (e) { tax = 0; }
    tax = this.convertToNumber(tax);
    value = ((value * tax)/100)/division;
    try { value = value.toFixed(2); }
    catch (e) { value = 0.00; }
    return value;
  }

  export = () => {
    let downloadLink;
    let filename = 'PurchaseGstReport';
    let dataType = 'application/vnd.ms-excel';
    let tableSelect = document.getElementById('export');
    let tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
    filename = filename?filename+'.xls':'excel_data.xls';
    downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    if(navigator.msSaveOrOpenBlob) {
      let blob = new Blob(['\ufeff', tableHTML], {
          type: dataType
      });
      navigator.msSaveOrOpenBlob( blob, filename);
    }
    else {
      downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
      downloadLink.download = filename;
      downloadLink.click();
    }
  }

  render() {
    let count = 0;
    let sino = 1;
    return (
      <div>
        <Title title='GST PURCHASE REPORT' openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          (
<div style={{padding: '0.5%'}}>
          <Grid>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <div style={{float: 'left', display: 'flex'}}>
                <TextField label="From" type="date"
                  onChange={(e) => this.setState({fromDate: e.target.value})}
                  defaultValue={this.state.fromDate} />
                <TextField style={{marginLeft: 20}} label="To" type="date"
                  onChange={(e) => this.setState({toDate: e.target.value})}
                  defaultValue={this.state.toDate} />
                <div style={{marginLeft:20, marginTop: '1%'}}>
                  <datalist id="branchs">
                      <option>ALL</option>
                      {this.state.branchOption.map((c) => {
                        return (<option id='box'>{c.id+'->'+c.name}</option>)
                      })}
                  </datalist>
                  <input style={{height: 35, width: '100%'}} onChange={this.selectBranch} autoComplete="on"
                  list="branchs" value={this.state.dropDown} />
                </div>
                <div style={{marginLeft:20, marginTop: '1%'}}>
                  <datalist id="GST">
                      <option>ALL</option>
                      <option>GSTIN AVAILABLE CUSTOMER</option>
                      <option>GSTIN NOT AVAILABLE CUSTOMER</option>
                  </datalist>
                  <input style={{height: 35, width: '100%'}} onChange={this.selectGstin} autoComplete="on"
                  list="GST" value={this.state.dropdowngstin} />
                </div>
                <Button variant="contained" color="primary" style={{marginLeft:20, marginTop: '1%'}} onClick={this.getPurchaseGstReport.bind(this)}>Go</Button>
                { this.state.menuPermission.exports ?
                  (
                    <Button variant="contained" color="primary" style={{marginLeft:20, marginTop: '1%'}} onClick={this.export}>Export</Button>
                  ):''
                }
                <div style={{marginLeft:20, marginTop: '1%'}}>
                  <HSNReport />
                </div>
                
              </div>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <div style={{overflow: 'auto', overflow: 'scroll', width: '98vw', height: '95vh' }}>
                <Table celled singleLine id='export'>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell id='tableheader'>Sino</Table.HeaderCell>
                      <Table.HeaderCell id='tableheader'>Voucher</Table.HeaderCell>
                      <Table.HeaderCell id='tableheader'>Date</Table.HeaderCell>
                      <Table.HeaderCell id='tableheader'>Customer</Table.HeaderCell>
                      <Table.HeaderCell id='tableheader'>State</Table.HeaderCell>
                      <Table.HeaderCell id='tableheader'>GSTIN</Table.HeaderCell>
                      {
                        this.state.data.map((c) => {
                          let lengthItem = Object.keys(c).length;
                          lengthItem = lengthItem - 9;
                          let row = [];
                          if (count == 0) {
                            for (var i = 0; i < lengthItem; i++) {
                              row.push(<Table.HeaderCell id='tableheader'>{this.fullTax(Object.keys(c)[i + 9])}</Table.HeaderCell>);
                              row.push(<Table.HeaderCell id='tableheader'>{this.halfTax(Object.keys(c)[i + 9], 'CGST')}</Table.HeaderCell>);
                              row.push(<Table.HeaderCell id='tableheader'>{this.halfTax(Object.keys(c)[i + 9], 'SGST')}</Table.HeaderCell>);
                            }
                            for (var i = 0; i < lengthItem; i++) {
                              row.push(<Table.HeaderCell id='tableheader'>{this.fullTaxIGST(Object.keys(c)[i + 9])}</Table.HeaderCell>);
                              row.push(<Table.HeaderCell id='tableheader'>{this.fullTaxIGSTVALUE(Object.keys(c)[i + 9])}</Table.HeaderCell>);
                            }
                            row.push(<Table.HeaderCell id='tableheader'>{'Taxable Amount'}</Table.HeaderCell>);
                            row.push(<Table.HeaderCell id='tableheader'>{'Tax Amount'}</Table.HeaderCell>);
                            row.push(<Table.HeaderCell id='tableheader'>{'Total'}</Table.HeaderCell>);
                          }
                          count++;
                          return row;
                        })
                      }
                    </Table.Row>
                  </Table.Header>
                  {
                    this.state.data.map((cc) => {
                      let GSTIN = cc.gstn;
                      if (!GSTIN) {
                        GSTIN = 'Not Available';
                      }
                      return (
                        <Table.Body>
                        <Table.Row>
                          <Table.Cell>{sino++}</Table.Cell>
                          <Table.Cell width={10}>{cc.voucher_no}</Table.Cell>
                          <Table.Cell>{this.dateFormate(cc.timestamp)}</Table.Cell>
                          <Table.Cell>{cc.name}</Table.Cell>
                          <Table.Cell>{cc.state}</Table.Cell>
                          <Table.Cell>{GSTIN}</Table.Cell>
                          {this.getRow(cc)}
                        </Table.Row>
                        </Table.Body>
                      )
                    })
                  }
                </Table>
              </div>
            </Grid.Column>
          </Grid>
        </div>
          ):
          (
            <center>
              You Are Not Allow To Access This Menu!!!
            </center>
          )

        }
        
      </div>
    );
  }
  dateFormate(value) {
    let date = value.split(' ')[0];
    date = date.split('-')[2]+'-'+date.split('-')[1]+'-'+date.split('-')[0];
    return date;
  }
}

export default PurchaserGSTReport;
